(function () {
    'use strict';
    a3_cabin_reports.directive('faceMasks', faceMasks);

    /**
       * @memberof CabinReports
       * @ngdoc directive
       * @name faceMasks
       * @restrict E
       * @description
       *   Implementation of Face Masks 
       *
       * Display the Face Masks Record Panel
       * @attr {String} flight-id
       * @example
       *   Usage:
       *   <face-masks flight-id="123"></face-masks>
       *   
       * @ngInject
       */
    function faceMasks(FlightFactory, FaceMasksFactory, $sce, $timeout) {
        /**
         * Initialize faceMasks
         * @memberof faceMasks
         * @param {service} scope the scope of this element
         * @param {service} element element that this direcive is assigned to
         * @param {service} attributes attributes of this element
         */
        function link(scope, element, attributes) {
            scope.togglePanel = togglePanel;
            scope.submit = submit;
            scope.numberDown = numberDown;
            scope.numberUp = numberUp;
            scope.validInput = validInput;
            scope.validateForm = validateForm;
            scope.requiredFields = false;
            scope.invalidForm = false;
            scope.LastUpdated = null;

            initializePanel();

            /**
             * Initialize Form Values
             * @memberof faceMasks
             */
            function initializePanel(){
                var flight = FlightFactory.getFlightFromStorage(scope.flightId);
                
               
                var DryStoreFound = 0;
                var DryStoreLeft = 0;
                var UniversalFound = 0;
                var UniversalLeft = 0;

                //Check if there is existing data
                if(flight.FaceMasks){
                    DryStoreFound = flight.FaceMasks.DryStoreFound;
                    DryStoreLeft = flight.FaceMasks.DryStoreLeft;
                    UniversalFound = flight.FaceMasks.UniversalFound;
                    UniversalLeft = flight.FaceMasks.UniversalLeft;
                    scope.LastUpdated = flight.FaceMasks.LastUpdated;
                }

                var masksForm = {
                    Types: [{
                                Type : "A",
                                Title: "FFP2 Masks",
                                Fields : [
                                    {
                                        Title: "Found",
                                        Value: DryStoreFound
                                    },
                                    {
                                        Title: "Left",
                                        Value: DryStoreLeft
                                    }
                                ]
                            },
                            {
                                Type : "B",
                                Title: "Surgical Face masks", 
                                Fields : [
                                    {
                                        Title: "Found",
                                        Value: UniversalFound
                                    },
                                    {
                                        Title: "Left",
                                        Value: UniversalLeft
                                    }
                                ]
                            }
                    ],
                    FlightId: scope.flightId
                };
                
                scope.submitMessage = '';
                scope.masksForm = masksForm;
                scope.showPanel = "masks";
                validateForm();
            }
            
            /**
             * Check if all required fields exist and have a valid value
             * @memberof faceMasks
             */
            function validateForm(){
                scope.requiredFields = scope.masksForm.Types.some(t => t.Fields.some(f => f.Value === null))
                scope.invalidForm = scope.masksForm.Types.some(t => t.Fields.some(f => f.Value === undefined))

                //Hide other alerts when form is invalid
                if(scope.requiredFields || scope.invalidForm){
                    scope.showPanel = "masks";
                }
            }

            /**
             * Toggle Panel
             * @memberof faceMasks
             * @param {number} panelId
             */
            function togglePanel(panelId) {
                $('#' + panelId).toggle();
            }

            function validInput(field){
                var isValid = true;

                if(field.Value == null || field.Value == undefined){
                    isValid = false;
                }

                return isValid;
            }

            /**
             * Decrease field value by 1
             * @memberof faceMasks
             * @param {object} field 
             */
            function numberDown(field){
                if(field.Value > 0){
                    field.Value--;
                }
            }   

            /**
             * Increase field value by 1
             * @memberof faceMasks
             * @param {object} field 
             */
            function numberUp(field){
                field.Value++;
            }

            /**
             * Submit form
             * @memberof faceMasks
             */
            function submit(){
                if(scope.isOffline){
                    scope.showPanel = "offline";
                }
                else{
                    scope.showPanel = "loading";
                    var DryStoreFound = scope.masksForm.Types.find(t => t.Type == "A").Fields.find(f => f.Title == "Found").Value;
                    var DryStoreLeft = scope.masksForm.Types.find(t => t.Type == "A").Fields.find(f => f.Title == "Left").Value;

                     var UniversalFound = scope.masksForm.Types.find(t => t.Type == "B").Fields.find(f => f.Title == "Found").Value;
                     var UniversalLeft = scope.masksForm.Types.find(t => t.Type == "B").Fields.find(f => f.Title == "Left").Value;
                  
                    var FlightMaskReport = {
                        FlightId : scope.masksForm.FlightId,
                        DryStoreFound : DryStoreFound,
                        DryStoreLeft : DryStoreLeft,
                        UniversalFound : UniversalFound, 
                        UniversalLeft : UniversalLeft,
                        LastUpdated : new Date()
                    };
    
                    FaceMasksFactory.submitFaceMaskReport(FlightMaskReport)
                        .then(res => handleSubmitResponse(res, FlightMaskReport.LastUpdated));
                }
            }

            /**
             * Manage API response
             * @param {object} res 
             * @param {date} timestamp 
             */
            function handleSubmitResponse(res, timestamp) {
                if (res.success) {
                    manageResponseMessage("success", res.message);
                    scope.LastUpdated = timestamp;
                    $timeout(function () { scope.showPanel = "masks"; }, 6000);
                }
                else {
                    manageResponseMessage("failure", res.message);
                }
            }

            /**
             * Manage message alerts
             * @param {string} panelToShow 
             * @param {string} message 
             */
            function manageResponseMessage(panelToShow, message) {
                scope.submitMessage = message;
                scope.showPanel = panelToShow;
            }
        }

        return {
            restrict: 'E',
            terminal: true,
            templateUrl: 'views/FaceMasks/faceMasks.tpl.html',
            scope: {
                flightId: '@',
                isOffline: '='
            },
            link: link
        }
    }

})();